import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProject } from "../Model/ProposalProject";

export async function deleteProposalProject(idProposalProject) {
	let response = await getAPIResponse("/v1/proposal-project/"+idProposalProject, {}, "DELETE");
	if (response === null) {
		return null;
	}
	let proposalProject = ProposalProject.createFromResponseData(response);
	return proposalProject;
}